import { render, staticRenderFns } from "./ReviewSidebar.vue?vue&type=template&id=42c123b3&scoped=true"
import script from "./ReviewSidebar.vue?vue&type=script&lang=ts"
export * from "./ReviewSidebar.vue?vue&type=script&lang=ts"
import style0 from "./ReviewSidebar.vue?vue&type=style&index=0&id=42c123b3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c123b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c123b3')) {
      api.createRecord('42c123b3', component.options)
    } else {
      api.reload('42c123b3', component.options)
    }
    module.hot.accept("./ReviewSidebar.vue?vue&type=template&id=42c123b3&scoped=true", function () {
      api.rerender('42c123b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ReviewSidebar.vue"
export default component.exports